export const initFormFile = function() {
  const inputs = document.querySelectorAll('input[type="file"]');
  const fileStorage = new WeakMap();

  inputs.forEach(input => {
    const isMultiple = input.hasAttribute('multiple');
    const parent = input.closest('[data-custom-file="parent"]');
    const textElement = parent?.querySelector('.form__file-text');
    let container = parent?.querySelector('[data-custom-file="container"]');

    // Инициализация хранилища
    if (isMultiple) {
      fileStorage.set(input, []);
    }

    // Функция создания контейнера
    const createContainer = () => {
      if (!container && parent) {
        container = document.createElement('div');
        container.setAttribute('data-custom-file', 'container');
        parent.appendChild(container);
      }
      return container;
    };

    // Функция удаления контейнера
    const removeContainer = () => {
      if (container && container.parentNode) {
        container.remove();
        container = null;
      }
    };

    // Функция создания сообщения об ошибке
    const createErrorMessage = (message) => {
      const messageInner = document.createElement('div');
      messageInner.className = 'form__message';
      messageInner.innerHTML = `
          <p>${message}</p>
          <button class="form__message-close" type="button" tabindex="-1" aria-label="Удалить сообщение">
            <svg width="14" height="14" aria-hidden="true">
              <use xlink:href="images/sprite_auto.svg#icon-close"></use>
            </svg>
          </button>
      `;

      // Обработчик закрытия сообщения
      const closeBtn = messageInner.querySelector('.form__message-close');
      closeBtn.addEventListener('click', () => {
        messageInner.remove();
      });

      // Автоудаление через 5 сек
      const timeoutId = setTimeout(() => {
        messageInner.remove();
      }, 5000);

      // Отмена таймера при ручном закрытии
      closeBtn.addEventListener('click', () => {
        clearTimeout(timeoutId);
      });

      parent?.insertBefore(messageInner, container || parent.firstChild);
    };

    const checkDuplicates = (newFiles, currentFiles) => {
      return newFiles.filter(file => currentFiles.some(f => f.name === file.name && f.size === file.size));
    };

    input.addEventListener('change', function(e) {
      const files = Array.from(e.target.files);
      const validateParent = parent?.closest('[data-validate-type="custom-upload"]');
      let isValid = false;

      if (isMultiple) {
        const currentFiles = fileStorage.get(input) || [];
        const duplicates = checkDuplicates(files, currentFiles);
        if (duplicates.length > 0) {
          // Показать сообщение об ошибке
          createErrorMessage(`Файлы уже добавлены: ${duplicates.map(f => `"${f.name}"`).join(', ')}`);
        }

        // Добавление новых файлов
        const newFiles = files.filter(file => !currentFiles.some(f => f.name === file.name && f.size === file.size));

        fileStorage.set(input, [...currentFiles, ...newFiles]);

        // Обновление данных
        const updatedFiles = [...currentFiles, ...newFiles];
        fileStorage.set(input, updatedFiles);

        // Синхронизация FileList
        const dataTransfer = new DataTransfer();
        updatedFiles.forEach(f => dataTransfer.items.add(f));
        input.files = dataTransfer.files;

        // Отрисовка файлов
        if (updatedFiles.length > 0) {
          createContainer().innerHTML = updatedFiles.map((file, index) => `
            <div class="form__files-item" data-index="${index}">
              <span>${file.name}</span>
              <button class="form__files-item-del" type="button" aria-label="Удалить файл"></button>
            </div>
          `).join('');
        } else {
          removeContainer();
        }

        isValid = updatedFiles.length > 0;
      } else {
        // Логика для одиночного файла
        const file = files[0];
        if (textElement) {
          textElement.textContent = file ? file.name : 'Файл не выбран';
        }
        isValid = !!file;
      }

      // Валидация
      if (validateParent) {
        validateParent.classList.toggle('is-valid', isValid);
        validateParent.classList.toggle('is-invalid', !isValid);
      }
    });

    // Обработчик удаления файлов
    parent?.addEventListener('click', (e) => {
      const deleteBtn = e.target.closest('.form__files-item-del');
      if (!deleteBtn || !isMultiple) {
        return;
      }

      const item = deleteBtn.closest('.form__files-item');
      const index = parseInt(item.dataset.index, 10);
      const currentFiles = fileStorage.get(input);

      currentFiles.splice(index, 1);
      fileStorage.set(input, currentFiles);

      // Обновление FileList
      const dataTransfer = new DataTransfer();
      currentFiles.forEach(f => dataTransfer.items.add(f));
      input.files = dataTransfer.files;

      // Перерисовка или удаление контейнера
      if (currentFiles.length > 0) {
        container.innerHTML = currentFiles.map((f, idx) => `
        <div class="form__files-item" data-index="${idx}">
          <span>${f.name}</span>
          <button class="form__files-item-del" type="button" aria-label="Удалить файл"></button>
        </div>
      `).join('');
      } else {
        removeContainer(); // Явное удаление контейнера
      }

      // Валидация
      const parentValidate = input.closest('[data-validate-type="custom-upload"]');
      if (parentValidate) {
        parentValidate.classList.toggle('is-valid', currentFiles.length > 0);
        parentValidate.classList.toggle('is-invalid', currentFiles.length === 0);
      }

      // console.log(input.files);
    });

    // Сброс формы
    input.closest('form')?.addEventListener('reset', () => {
      if (isMultiple) {
        fileStorage.set(input, []);
        removeContainer();
      } else {
        textElement.textContent = 'Файл не выбран';
      }

      const validateParent = parent?.closest('[data-validate-type="custom-upload"]');
      validateParent?.classList.remove('is-valid', 'is-invalid');
    });
  });
};
